import { render, staticRenderFns } from "./CompanyEmployeeCreditDialog2.vue?vue&type=template&id=2719e890&scoped=true"
import script from "./CompanyEmployeeCreditDialog2.vue?vue&type=script&lang=js"
export * from "./CompanyEmployeeCreditDialog2.vue?vue&type=script&lang=js"
import style0 from "./CompanyEmployeeCreditDialog2.vue?vue&type=style&index=0&id=2719e890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2719e890",
  null
  
)

export default component.exports